module.exports = __WEBPACK_EXTERNAL_MODULE_47__;


//////////////////
// WEBPACK FOOTER
// external {"root":"angularResizableElement","commonjs":"angular-resizable-element","commonjs2":"angular-resizable-element"}
// module id = 47
// module chunks = 0